function createManagementScheduleDateMethods({ DateFormatter, Window }) {
  return {
    handleDate(day) {
      if (day) {
        this.date = day.id;
        Window.scrollBy({ top: 200, left: 0, behavior: 'smooth' });
      }
      this.scheduleList = this.allScheduleList.filter(
        (item) => DateFormatter(item.date).format('YYYY-MM-DD') === this.date
      );
    },
  };
}

module.exports = createManagementScheduleDateMethods;
